export const getFileExtension = (fileName) => {
  return fileName.split(".").pop();
};
